import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import {
  CardContent,
  CardHeader,
  Divider,
  Stack,
  Typography,
} from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ConnectingInfoCardProps as Props } from './types';

export const ConnectingInfoCard = memo(
  ({ className, fullName, descriptions }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('ConnectingInfoCard', className)}
        variant="outlined"
        sx={SX.root}
        headerDivider
      >
        <CardHeader
          title={
            <Stack sx={SX.header}>
              <Icon name="wireless" size={24} color="primary.500" />

              <Typography variant="body3" fontWeight={600} color="primary.700">
                Connecting with {fullName}
              </Typography>
            </Stack>
          }
        />
        {descriptions.map((i: string, index: number, arr: string[]) => (
          <Stack key={index}>
            <CardContent>
              <Typography variant="body4" color="grey.600" fontWeight={400}>
                {i}
              </Typography>
            </CardContent>

            {index !== arr.length - 1 && <Divider sx={SX.dashed} />}
          </Stack>
        ))}
      </Styled.Wrapper>
    );
  }
);

ConnectingInfoCard.displayName = 'ConnectingInfoCard';
